var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CategoriesContent",class:{
		'CategoriesContent--dark': _vm.client.name === 'Dolci',
		'CategoriesContent--light': _vm.client.name !== 'Dolci',
	}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('h3',{staticClass:"CategoriesContent__title"},[_vm._v(_vm._s(_vm.getTranslation(item.categories[0].name)))]),_c('ProductsList',{attrs:{"list":item.items,"selectProduct":_vm.selectProduct}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }